import { render, staticRenderFns } from "./OneBottleConfirmationModal.vue?vue&type=template&id=0f96d4ef&scoped=true"
import script from "./OneBottleConfirmationModal.vue?vue&type=script&lang=js"
export * from "./OneBottleConfirmationModal.vue?vue&type=script&lang=js"
import style0 from "./OneBottleConfirmationModal.vue?vue&type=style&index=0&id=0f96d4ef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f96d4ef",
  null
  
)

export default component.exports